import { all } from "redux-saga/effects";
import adminSagas from "./admin/saga";

export default function* rootSaga() {
  yield all([adminSagas()]);
}
